export const convertToPublicSpotifyUrl = (apiUrl: string): string => {
  if (!apiUrl) {
    return ''
  }
  const match = apiUrl.match(/\/playlists\/([a-zA-Z0-9]+)/)
  return match ? `https://open.spotify.com/playlist/${match[1]}` : apiUrl
}
